import React from 'react';
import PropTypes from 'prop-types';

const LoadingIndicator = props => (
    <div style={{ height: '6rem', textAlign: 'center' }}>
        <div className="loading-animation" />
        <span>{props.label}</span>
    </div>
);

LoadingIndicator.propTypes = {
    label: PropTypes.string,
};

LoadingIndicator.defaultProps = {
    label: '',
};

export default LoadingIndicator;



// WEBPACK FOOTER //
// ./src/frontend/components/LoadingIndicator.jsx